import { InitialPayload, readArray } from '../shared/payloadReaders';

export const CANVAS_WIDTH = 256;
export const CANVAS_HEIGHT = 490;
export const MIN_BLOCK_SIZE = 24;
export const CARD_BARCODE_ANCHOR = '#NUM_CARTE_BC#';

export type BlockType = 'text' | 'barcode' | 'image';
export type TextAlign = 'left' | 'center' | 'right' | 'justify';

export interface CashdeskBlock {
  id: string;
  type: BlockType;
  content: string;
  anchor?: string;
  src?: string;
  x: number;
  y: number;
  width: number;
  height: number;
  fontWeight: 'normal' | 'bold';
  fontStyle: 'normal' | 'italic';
  textDecoration: 'none' | 'underline';
  textAlign: TextAlign;
  fontSize: number;
  rotation: number;
  zIndex: number;
}

export type NewBlock = Pick<CashdeskBlock, 'type' | 'content' | 'width' | 'height'> & Partial<Pick<CashdeskBlock, 'anchor' | 'src'>>;

export const buildBlock = (id: string, zIndex: number, block: NewBlock): CashdeskBlock => ({
  id,
  x: 10,
  y: 10,
  fontWeight: 'normal',
  fontStyle: 'normal',
  textDecoration: 'none',
  textAlign: 'left',
  fontSize: 14,
  rotation: 0,
  zIndex,
  ...block,
});

export const readBlocks = (payload: InitialPayload): CashdeskBlock[] => readArray<CashdeskBlock>(payload, 'blocks');

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));
